import { generateUUID, unescapeSpecialHTMLChars, replaceUrlsWithLinks } from '@gp/utils/common';

/**
 * Tinymce富文本组件粘贴时，处理粘贴的内容
 * 1、反转译特殊的HTML字符
 * 2、把内敛style中text-indent属性值为负数的调整为0
 * 3、处理超链接标签（在保留粘贴时本身就有的a标签超链接，同时也把普通文本的超链接转换为a标签超链接）
 * @param str 处理后的文本内容
 */
export const convertTextOnPaste = (str?: string): string => {
  if (!str) return '';
  // 反转译HTML字符串中的特殊HTML字符
  let strTmp = unescapeSpecialHTMLChars(str);

  // 把HTML字符串中内敛style中的text-indent为负数的替换成0
  strTmp = strTmp.replaceAll(/text-indent:\s*-[^\s;]+/g, 'text-indent: 0');

  const divNode = document.createElement('div');
  divNode.innerHTML = strTmp;
  const aNodes = divNode.querySelectorAll('a');
  const aNodesMap = new Map<string, string>();

  for (const aNode of aNodes) {
    const aNodeId = generateUUID();
    const textNode = document.createTextNode(`@@${aNodeId}@@`);
    aNodesMap.set(aNodeId, aNode.outerHTML);
    aNode.parentNode?.replaceChild(textNode, aNode);
  }

  strTmp = replaceUrlsWithLinks(divNode.innerHTML);

  aNodesMap.forEach((value, key) => {
    strTmp = strTmp.replace(new RegExp(`@@${key}@@`), value);
  });

  return strTmp;
};
